import PackageList from "./PackageList";
import PackageCreate from "./PackageCreate";
import PackageEdit from "./PackageEdit";


const packages = {
  list: PackageList,
  create: PackageCreate,
  edit: PackageEdit,
};

export default packages;